import React from 'react';
import Box from '@mui/material/Box';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({ children }: IProps) => {
    return <Box className="button-bar">{children}</Box>;
};

const ButtonBarComponent = React.memo(Component);

export default ButtonBarComponent;
